import React, { useContext } from 'react'
import { getBookedSlotStripColor } from 'src/clinic/components/ClinicManageBookingsPage/utils/bookedSlotColorUtils'
import { BOOKING_STATUSES, BOOKING_PAYMENT_STATUSES } from 'src/consumer/constants'

function getStylesForBookedEvent(eventInfo, isForListing = false, theme = 'light') {
  // Use the same color logic as day calendar page
  const bookedSlot = {
    status: eventInfo?.status,
    sessionStatus: eventInfo?.sessionStatus,
    markedCompleted: eventInfo?.markedCompleted,
    visitEventType: eventInfo?.visitEventType,
    paymentStatus: eventInfo?.paymentStatus,
  }
  const colors = getBookedSlotStripColor(bookedSlot, false, true)
  
  // Use leftStripColor for background, or fallback to borderColor
  const bgColor = colors.leftStripColor || colors.borderColor
  const chipColor = colors.leftStripBorderColor || colors.borderColor
  let opacity = 1

  // Cancelled status takes precedence and reduces opacity
  if (eventInfo?.status === 'cancelled') {
    opacity = 0.7
  }
  
  if (isForListing) {
    return {
      backgroundColor: bgColor,
      opacity: opacity,
      chipColor: chipColor,
    }
  }
  return {}
}

export default function ListingVerticalStripForEventStatus({ bookedEventData, containerStyles }) {
  // Use the same color logic as day calendar page
  const styles = getStylesForBookedEvent(bookedEventData, true, 'light')

  // Determine status text - cancelled takes precedence
  const getStatusText = (eventInfo) => {
    // Cancelled status takes precedence
    if (eventInfo?.status === 'cancelled') {
      return 'CANCELLED'
    }
    if (eventInfo?.sessionStatus === 'in-progress') {
      return 'IN PROGRESS'
    }
    if (eventInfo?.sessionStatus === 'marked-completed') {
      return 'COMPLETED'
    }
    if (eventInfo?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING) {
      return 'PAYMENT PENDING'
    }

    return 'BOOKED'
  }

  const statusText = getStatusText(bookedEventData)
  const backgroundColor = styles.chipColor || '#6366F1' // Default indigo if no specific color
  const opacity = styles.opacity || 1

  return (
    <VerticalStripForEventStatusUIOnly
      backgroundColor={backgroundColor}
      opacity={opacity}
      statusText={statusText}
      containerStyles={containerStyles}
    />
  )
}

export function VerticalStripForEventStatusUIOnly({
  backgroundColor,
  opacity,
  statusText,
  containerStyles = {},
}) {
  return (
    <div
      style={{
        width: '40px',
        height: '100%',
        backgroundColor: backgroundColor,
        opacity: opacity,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        marginRight: '8px',
        ...containerStyles,
        // borderRadius: '8px 0 0 8px',
        // boxShadow: '2px 0 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      {/* Status indicator dot */}
      {/* <div
        style={{
          position: 'absolute',
          top: '12px',
          width: '8px',
          height: '8px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '50%',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        }}
      /> */}

      {/* Vertical status text */}
      <span
        style={{
          transform: 'rotate(-180deg)',
          writingMode: 'vertical-lr',
          color: 'white',
          fontSize: '12px',
          fontWeight: '600',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
        }}
      >
        {statusText}
      </span>

      {/* Bottom accent line */}
      {/* <div
        style={{
          position: 'absolute',
          bottom: '0',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '20px',
          height: '3px',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: '2px 2px 0 0',
        }}
      /> */}
    </div>
  )
}
